import { Injectable } from '@angular/core';
import { CommunicationManagerService } from './communication-manager.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReimbursementService {
  constructor(private cm: CommunicationManagerService) {}

  getReimbursementDataForCompany(
    companyId: string
  ): Observable<Array<{ name: string; amount: number }>> {
    return this.cm.get(`reimbursement`, [
      { headerName: 'companyId', headerValue: companyId },
    ]) as Observable<Array<{ name: string; amount: number }>>;
  }
}
